module.exports = __webpack_public_path__ + "img/dgjg2335_2.9e8c254e.svg";